var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.264 27.5h9.45c2.08 0 3.47-1.326 3.47-3.316V3.816c0-1.99-1.39-3.316-3.47-3.316h-9.45C2.185.5.794 1.826.794 3.816v20.368c0 1.99 1.391 3.316 3.47 3.316m.268-2.053c-1.084 0-1.684-.574-1.684-1.595V4.148c0-1.02.6-1.595 1.684-1.595h8.928c1.07 0 1.67.574 1.67 1.595v19.704c0 1.02-.6 1.595-1.67 1.595zm2.92-20.088h3.087a.89.89 0 0 0 .893-.905.887.887 0 0 0-.893-.893H7.452a.89.89 0 0 0-.905.893c0 .51.395.905.905.905m-1.16 19.157h5.42c.345 0 .587-.243.587-.6s-.242-.587-.587-.587h-5.42c-.344 0-.6.23-.6.587s.255.6.6.6"
  })));
};
export default SvgPhone;